import React, { useState } from "react";
import styled from "./FinalMessage.module.css";

const FinalMessage = function (props) {
  const [imgNumber, setImgNumber] = useState(1);

  const imgNumHandler = function () {
    let randNum;
    randNum = Math.ceil(Math.random() * 10);
    if (randNum === 10) {
      randNum = Math.ceil(Math.random() * 10);
    }

    setImgNumber(randNum);
  };

  return (
    <React.Fragment>
      <header>
        <h1>Hello {props.name}</h1>
        <p>Enjoy some hand picked memes.</p>
      </header>

      <div className={styled.meme}>
        <img src={require(`./img/0${imgNumber}.png`)} alt="Meme" />
        <button onClick={imgNumHandler}>
          <h3>New Meme</h3>
        </button>
      </div>
    </React.Fragment>
  );
};

export default FinalMessage;
